var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"copyright"},[_vm._v(" "+_vm._s(_vm.$t('core.copyright'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }